import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SimpleClientRegister } from "store/actions/authActions/SimpleClientRegister";
import { useAppDispatch } from "store/hooks";
import skipSvg from "../../assets/svg/skip.svg";
import spinnerSvg from "../../assets/svg/spinner-blue.svg";
import { UserData } from "pages/SignUpPage";
import { LoginWithGoogle } from "store/actions/authActions/LoginWithGoogle";
import { LoginWithDiscord } from "store/actions/authActions/LoginWithDiscord";
import { useWindowSize } from "hooks/useWindowSize";

type Props = {
  userData: UserData | null;
  setEmailInUseError: React.Dispatch<React.SetStateAction<boolean>>;
  setForbiddenError: React.Dispatch<React.SetStateAction<boolean>>;
  setUserData: React.Dispatch<React.SetStateAction<UserData | null>>;
  qrTokenToValidate: string | undefined;
  skipButtonIsLoading: boolean;
  setSkipButtonIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  googleToken: string | null;
  discordCode: string | null;
  setRedirect: React.Dispatch<React.SetStateAction<boolean>>;
};

export const skipReferral = () => {};

export const SkipButton: React.FC<Props> = ({
  userData,
  setEmailInUseError,
  setForbiddenError,
  qrTokenToValidate,
  skipButtonIsLoading,
  setSkipButtonIsLoading,
  googleToken,
  discordCode,
  setRedirect,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const language = t("localization_testing");
  const [width] = useWindowSize();

  return (
    <button
      disabled={skipButtonIsLoading}
      type="button"
      onClick={() => {
        if (!!discordCode) {
          dispatch(
            LoginWithDiscord(
              language,
              discordCode,
              true,
              true,
              setRedirect,
              navigate,
              qrTokenToValidate
            )
          );
        }
        if (!!googleToken) {
          dispatch(
            LoginWithGoogle(
              language,
              googleToken,
              true,
              true,
              navigate,
              setRedirect,
              setSkipButtonIsLoading,
              qrTokenToValidate
            )
          );
        }
        if (!!userData) {
          dispatch(
            SimpleClientRegister(
              userData.firstName,
              userData.lastName,
              userData.email,
              userData.password,
              setSkipButtonIsLoading,
              setEmailInUseError,
              setForbiddenError,
              setRedirect,
              navigate,
              dispatch,
              language,
              width,
              qrTokenToValidate
            )
          );
        }
      }}
      className="flex h-10 items-center space-x-2"
    >
      {!skipButtonIsLoading && (
        <>
          <span className="text-blue-500 font-bold text-lg">
            {t("refer.skip")}
          </span>
          <img className="h-5" src={skipSvg} alt="skip" />
        </>
      )}
      {skipButtonIsLoading && (
        <div className="w-full h-full flex justify-center items-center">
          <img className="h-6 animate-spin" src={spinnerSvg} alt="loading" />
        </div>
      )}
    </button>
  );
};
